var description_default = {
  "subtitle": "TJR9I",
  "descriptionItem": "u1Nox"
};
export {
  description_default as default
};
//# sourceMappingURL=description-scss.js.map
